import { render, staticRenderFns } from "./ContactSourcesList.vue?vue&type=template&id=2226a644"
import script from "./ContactSourcesList.vue?vue&type=script&lang=js"
export * from "./ContactSourcesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports